// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 20px 13px;
  position: relative;
  text-align: center;
  background: var(--background-default);
}
.wrapper .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  width: 25px;
  height: 25px;
  padding: 0px;
  z-index: 99;
}
.wrapper h3 {
  padding: 20px 10px 10px;
}
.wrapper .items {
  width: 100%;
  overflow-y: auto;
  max-height: 50vh;
  padding-bottom: 70px;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  color: var(--color-black);
  font-family: AppFontMedium, sans-serif;
  margin-right: 0;
  font-size: 14px;
  text-wrap: auto;
}
@media (max-width: 992px) {
  ion-button .buuton-text {
    font-size: 10px;
  }
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

.center-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-family: Title;
  font-size: 40px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
}

.button-footer-block {
  margin: 0px !important;
  background: #fff !important;
  padding: 15px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  border-top: 1px solid var(--color-black);
}
@media (min-width: 991px) {
  .button-footer-block {
    width: 100%;
    border-right: 1px solid var(--color-black);
  }
}
.button-footer-block .left-button {
  width: 45%;
  height: 40px;
  background: transparent;
  border-radius: 26px;
  border: 1px solid #000000;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-footer-block .left-button.disabled {
  opacity: 0.5;
}
.button-footer-block .left-button h2,
.button-footer-block .left-button p {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 2%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.button-footer-block .button-checkout {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 54%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ion-color-primary);
  border-radius: 26px;
}
.button-footer-block .button-checkout .left-price {
  background: #ecefec;
  height: 100%;
  border-radius: 26px;
  border: 1px solid #000000;
  padding: 0px 10px;
  position: relative;
}
.button-footer-block .button-checkout .left-price .option-total-quantity {
  position: absolute;
  top: -10px;
  right: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #000000;
  border-radius: 50px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AppFontBold;
  font-size: 14px;
  letter-spacing: 0.08em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.button-footer-block .button-checkout:hover {
  background: var(--ion-color-primary-tint);
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
.button-footer-block .button-checkout p {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 2%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  font-size: 14px;
}
.button-footer-block .button-checkout .right-checkout {
  cursor: pointer;
  padding: 0px 15px 0px 10px;
  text-transform: uppercase;
  text-align: center;
}
.button-footer-block .button-checkout .right-checkout p {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 2%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/app/components/choose-size-of-product/choose-size-of-product.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;AADD;AAGC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADF;AAIC;EACC,uBAAA;AAFF;AAIC;EACC,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAFF;;AAOA;EACC,kBAAA;AAJD;AAMC;EACC,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AAJF;AC5BE;ED2BD;IAOE,eAAA;EAFD;AACF;AAIC;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAFF;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAFD;;AAIA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AADD;;AAIA;EACC,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,wCAAA;AADD;AC5EE;EDgEF;IAeE,WAAA;IACA,0CAAA;EACA;AACF;AACC;EACC,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACC,YAAA;AACH;AAIE;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAFH;AAMC;EACC,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,mBAAA;AAJF;AAKE;EACC,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAHH;AAKG;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AALJ;AAQE;EACC,yCAAA;AANH;AAQE;EACC,YAAA;AANH;AAQE;EACC,YAAA;AANH;AAQE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AANH;AASE;EACC,eAAA;EACA,0BAAA;EAYA,yBAAA;EACA,kBAAA;AAlBH;AAOG;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AALJ","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tpadding: 20px 13px;\n\tposition: relative;\n\ttext-align: center;\n\tbackground: var(--background-default);\n\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t}\n\n\th3 {\n\t\tpadding: 20px 10px 10px;\n\t}\n\t.items {\n\t\twidth: 100%;\n\t\toverflow-y: auto;\n\t\tmax-height: 50vh;\n\t\tpadding-bottom: 70px;\n\t}\n}\n\n\nion-button {\n\tposition: relative;\n\n\t.buuton-text {\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tmargin-right: 0;\n\t\tfont-size: 14px;\n\t\ttext-wrap: auto;\n\t\t@include mobile {\n\t\t\tfont-size: 10px;\n\t\t}\n\t}\n\t.button-icon {\n\t\tposition: absolute;\n\t\tright: 5px;\n\t\theight: 34px;\n\t\twidth: 34px;\n\t}\n}\n.center-element {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.title {\n\tfont-family: Title;\n\tfont-size: 40px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\ttext-transform: uppercase;\n}\n\n.button-footer-block {\n\tmargin: 0px !important;\n\tbackground: #fff !important;\n\tpadding: 15px;\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\tz-index: 999;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tfont-size: 14px;\n\tborder-top: 1px solid var(--color-black);\n\t@include desktop {\n\t\twidth: 100%;\n\t\tborder-right: 1px solid var(--color-black);\n\t}\n\n\t.left-button {\n\t\twidth: 45%;\n\t\theight: 40px;\n\t\tbackground: transparent;\n\t\tborder-radius: 26px;\n\t\tborder: 1px solid #000000;\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\t.buuton-text {\n\t\t}\n\n\t\th2,\n\t\tp {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 2%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\n\t.button-checkout {\n\t\twidth: fit-content;\n\t\tmax-width: 54%;\n\t\theight: 40px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground: var(--ion-color-primary);\n\t\tborder-radius: 26px;\n\t\t.left-price {\n\t\t\tbackground: #ecefec;\n\t\t\theight: 100%;\n\t\t\tborder-radius: 26px;\n\t\t\tborder: 1px solid #000000;\n\t\t\tpadding: 0px 10px;\n\t\t\tposition: relative;\n\n\t\t\t.option-total-quantity {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -10px;\n\t\t\t\tright: 0;\n\t\t\t\theight: 20px;\n\t\t\t\twidth: 20px;\n\t\t\t\tborder: 1px solid #000000;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tbackground: #fff;\n\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tletter-spacing: 0.08em;\n\t\t\t\ttext-align: center;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: var(--ion-color-primary-tint);\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\tp {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 2%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 14px;\n\t\t}\n\n\t\t.right-checkout {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 0px 15px 0px 10px;\n\n\t\t\tp {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 120%;\n\t\t\t\tletter-spacing: 2%;\n\t\t\t\ttext-align: center;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
